"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const SvgSummary_vue_1 = __importDefault(require("@common/components/SvgSummary.vue"));
const debounce_1 = require("@common/tsutils/debounce");
let ClusterEditorReport = class ClusterEditorReport extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.clusteredIdx = null;
        this.disabled = false;
        // Badge behaviour
        this.showBadge = false;
        //
        // This two attributes allow to avoid infinite loops
        //
        this.insideChange = false;
        this.outsideChange = false;
    }
    get _uid() {
        return Math.random();
    }
    mounted() {
        this.disabled = this.sampleDisabledFn(this.sample);
    }
    get classes() {
        const classes = {};
        if (this.clusteredIdx !== null) {
            classes.cluster__assigned = true;
            classes['cluster__assigned--' + (this.clusteredIdx + 1)] = true;
        }
        return classes;
    }
    classesCluster(idx) {
        const classes = {};
        // It's main class
        classes['cluster__move--' + (idx + 1)] = true;
        // Check if selected
        if (idx === this.clusteredIdx) {
            classes.clustered = true;
        }
        return classes;
    }
    clickNext() {
        if (this.disabled) {
            return;
        }
        if (this.clusteredIdx === null) {
            this.clusteredIdx = 0;
        }
        else if (this.clusteredIdx >= this.clusters.length - 1) {
            this.clusteredIdx = null;
        }
        else {
            this.clusteredIdx++;
        }
    }
    clickCluster(idx) {
        if (this.disabled) {
            return;
        }
        this.clusteredIdx = idx;
    }
    triggerBadge() {
        this.showBadge = true;
    }
    hideBadge() {
        this.showBadge = false;
    }
    onClusterChangeFromOutside() {
        if (this.insideChange) {
            this.insideChange = false;
            return;
        }
        this.outsideChange = true;
        this.onClusterChangeFromOutside2();
    }
    onClusterChangeFromOutside2() {
        // Update the selected idx if needed
        const myIdx = this.clusters.getClusterIdx(this.sample);
        if (this.clusteredIdx !== myIdx) {
            this.clusteredIdx = myIdx;
        }
        this.$nextTick(() => { this.outsideChange = false; });
    }
    onChangeClusterIdx() {
        if (this.outsideChange)
            return;
        this.onChangeClusterIdx2();
    }
    onChangeClusterIdx2() {
        this.insideChange = true;
        this.clusters.addSample(this.sample, this.clusteredIdx);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorReport.prototype, "sample", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorReport.prototype, "clusters", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorReport.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorReport.prototype, "sampleDisabledFn", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('clusters', { deep: true })
], ClusterEditorReport.prototype, "onClusterChangeFromOutside", null);
__decorate([
    (0, debounce_1.PerInstanceDebounce)(100)
], ClusterEditorReport.prototype, "onClusterChangeFromOutside2", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('clusteredIdx')
], ClusterEditorReport.prototype, "onChangeClusterIdx", null);
__decorate([
    (0, debounce_1.PerInstanceDebounce)(150)
], ClusterEditorReport.prototype, "onChangeClusterIdx2", null);
ClusterEditorReport = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            SvgSummary: SvgSummary_vue_1.default
        }
    })
], ClusterEditorReport);
exports.default = ClusterEditorReport;
